'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; desc = parent = getter = undefined; _again = false; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactStyle = require('react-style');

var _reactStyle2 = _interopRequireDefault(_reactStyle);

var OverlayStyles = _reactStyle2['default'].create({
  normalOverlayStyle: {
    height: '100%',
    position: 'fixed',
    width: '100%',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    backgroundColor: 'rgb(0,0,0)',
    opacity: '.01',
    zIndex: '2',
    visibility: 'hidden',
    transition: 'visibility 0s ' + 'linear .4s, ' + 'opacity .4s ' + 'cubic-bezier(.4, 0, .2, 1), ' + 'z-index 0s linear .4s'
  },

  normalOverlayVisibleStyle: {
    opacity: '.3',
    // NOTE: wonder what's better this or
    // transparent images (both suck for this)
    filter: 'alpha(opacity=30)',
    visibility: 'visible',
    transition: 'visibility 0s ' + 'linear 0s, ' + 'opacity .4s ' + 'cubic-bezier(.4, 0, .2, 1), ' + 'z-index 0s linear 0s'
  }
});

var _default = (function (_React$Component) {
  var _class = function _default() {
    _classCallCheck(this, _class);

    _get(Object.getPrototypeOf(_class.prototype), 'constructor', this).call(this);
  };

  _inherits(_class, _React$Component);

  _createClass(_class, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var onClick = _props.onClick;
      var show = _props.show;
      var normalOverlayVisibleStyle = OverlayStyles.normalOverlayVisibleStyle;
      var normalOverlayStyle = OverlayStyles.normalOverlayStyle;

      var overlayStyles = [normalOverlayStyle];

      if (show) {
        overlayStyles.push(normalOverlayVisibleStyle);
      }

      return _react2['default'].createElement('div', {
        onClick: onClick ? onClick : function () {},
        styles: overlayStyles });
    }
  }], [{
    key: 'displayName',
    value: 'Overlay',
    enumerable: true
  }, {
    key: 'propTypes',
    value: {
      onClick: _react.PropTypes.func.isRequired,
      show: _react.PropTypes.bool
    },
    enumerable: true
  }]);

  return _class;
})(_react2['default'].Component);

exports['default'] = _default;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-material/lib/Overlay.js
 ** module id = 208
 ** module chunks = 0
 **/